import React from 'react'

export interface IconCommentProps {
    className?: string
    fill?: string
}

export const IconComment: React.FC<IconCommentProps> = ({
    className,
    fill = '#535556',
}) => (
    <svg
        className={className}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.666 3.5C11.666 3.17783 11.4048 2.91667 11.0827 2.91667H2.91602C2.59385 2.91667 2.33268 3.17783 2.33268 3.5V8.16667C2.33268 8.48883 2.59385 8.75 2.91602 8.75H5.24935C5.57152 8.75 5.83268 9.01117 5.83268 9.33333V10.8418L7.75358 8.9209L7.79631 8.88216C7.90011 8.79709 8.03063 8.75 8.16602 8.75H11.0827C11.4048 8.75 11.666 8.48883 11.666 8.16667V3.5ZM4.67171 5.25C4.99388 5.25 5.25505 5.51117 5.25505 5.83333C5.25505 6.1555 4.99388 6.41667 4.67171 6.41667H4.66602C4.34385 6.41667 4.08268 6.1555 4.08268 5.83333C4.08268 5.51117 4.34385 5.25 4.66602 5.25H4.67171ZM7.00505 5.25C7.32721 5.25 7.58838 5.51117 7.58838 5.83333C7.58838 6.13536 7.359 6.38394 7.06486 6.41382L7.00505 6.41667H6.99935C6.67718 6.41667 6.41602 6.1555 6.41602 5.83333C6.41602 5.51117 6.67718 5.25 6.99935 5.25H7.00505ZM9.33838 5.25C9.66055 5.25 9.92171 5.51117 9.92171 5.83333C9.92171 6.13536 9.69234 6.38394 9.39819 6.41382L9.33838 6.41667H9.33268C9.01052 6.41667 8.74935 6.1555 8.74935 5.83333C8.74935 5.51117 9.01052 5.25 9.33268 5.25H9.33838ZM12.8327 8.16667C12.8327 9.13317 12.0492 9.91667 11.0827 9.91667H8.40755L5.66178 12.6624C5.49495 12.8293 5.24402 12.8792 5.02604 12.7889C4.80811 12.6986 4.66602 12.4859 4.66602 12.25V9.91667H2.91602C1.94952 9.91667 1.16602 9.13317 1.16602 8.16667V3.5C1.16602 2.5335 1.94952 1.75 2.91602 1.75H11.0827C12.0492 1.75 12.8327 2.5335 12.8327 3.5V8.16667Z"
            fill={fill}
        />
    </svg>
)
IconComment.displayName = 'IconComment'
